import React from "react"

class CampCampSearch extends React.Component {
  render() {
    return <div>CAMP CAMP SEARCH</div>
  }
}

export default CampCampSearch



// WEBPACK FOOTER //
// ./src/scenes/Camp/CampCampSearch/index.js